module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Typewriter-Medium.79dd1ce7.woff";